import React, { useId } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { driverFromCustomer } from '../lib/bookingChecks';

const FIELDS = [
  ['first_name', 'Vorname', 'text', true],
  ['last_name', 'Nachname', 'text', true],
  ['date_of_birth', 'Geburtsdatum', 'date'],
  ['address', 'Anschrift', 'text'],
  ['driver_license_number', 'Führerscheinnummer', 'text'],
  ['driver_license_expiry', 'Führerschein gültig bis', 'date'],
];

export default function AdditionalDriversFields({ value = [], onChange, customers = [], mainCustomerId }) {
  const prefix = useId();
  const update = (index, key, next) => onChange(value.map((driver, i) => i === index ? { ...driver, [key]: next || (key === 'date_of_birth' || key === 'driver_license_expiry' ? null : '') } : driver));
  return (
    <section className="space-y-3" aria-label="Zusatzfahrer">
      <div className="flex items-center justify-between gap-2">
        <h3 className="overline">Zusatzfahrer</h3>
        <Button type="button" variant="outline" size="sm" disabled={value.length >= 20} onClick={() => onChange([...value, { first_name: '', last_name: '', date_of_birth: null, address: '', driver_license_number: '', driver_license_expiry: null }])}>Zusatzfahrer hinzufügen</Button>
      </div>
      {customers.length > 0 && (
        <div>
          <Label htmlFor={`${prefix}-customer`}>Zusatzfahrer aus Kunden übernehmen</Label>
          <select id={`${prefix}-customer`} className="input-swiss w-full px-3 py-2" value="" disabled={value.length >= 20} onChange={(event) => {
            const customer = customers.find(c => c.id === event.target.value);
            if (customer) onChange([...value, driverFromCustomer(customer)]);
          }}>
            <option value="">Kunde auswählen …</option>
            {customers.filter(c => c.id !== mainCustomerId && !value.some(d => d.first_name === c.first_name && d.last_name === c.last_name && d.date_of_birth === (c.date_of_birth?.slice(0, 10) || null))).map(c => <option key={c.id} value={c.id}>{c.first_name} {c.last_name}{c.customer_number ? ` · ${c.customer_number}` : ''}</option>)}
          </select>
          <p className="text-xs text-[#8A94A6] mt-1">Die Angaben werden für diese Buchung übernommen und können hier angepasst werden.</p>
        </div>
      )}
      <p className="text-xs text-[#8A94A6]">Fahrerangaben für diese Buchung und den Mietvertrag. Einen Aufpreis bei Bedarf separat über die Extras erfassen.</p>
      {value.map((driver, index) => (
        <fieldset key={index} className="border border-[#E2E4E9] rounded-sm p-3 space-y-3">
          <legend className="px-1 text-sm font-medium">Zusatzfahrer {index + 1}</legend>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {FIELDS.map(([key, label, type, required]) => (
              <div key={key}>
                <Label htmlFor={`${prefix}-${index}-${key}`}>{label}{required ? ' *' : ''}</Label>
                <Input id={`${prefix}-${index}-${key}`} type={type} required={required} maxLength={key === 'address' ? 500 : 100} pattern={required ? '.*\\S.*' : undefined} value={driver[key] || ''} onChange={(event) => update(index, key, event.target.value)} className="input-swiss" />
              </div>
            ))}
          </div>
          <Button type="button" variant="outline" size="sm" onClick={() => onChange(value.filter((_, i) => i !== index))}>Zusatzfahrer entfernen</Button>
        </fieldset>
      ))}
    </section>
  );
}
